import { fontSize, type TypographyProps } from '@material-ui/system'
import { css } from 'styled-components'

export interface IBaseBadgeProps extends Pick<TypographyProps, 'fontSize'> {
  size?: 'small' | 'medium'
}

export const BaseBadgeStyles = css<IBaseBadgeProps>`
  ${fontSize}

  line-height: 1;
  font-weight: ${(props) => props.theme.typography.fontWeightMedium};
  font-family: ${(props) => props.theme.fontFamily.body};
  padding: ${(props) =>
    props.size === 'small'
      ? `${props.theme.typography.pxToRem(2)} ${props.theme.typography.pxToRem(8)}`
      : `${props.theme.typography.pxToRem(4)} ${props.theme.typography.pxToRem(8)}`};

  display: inline-flex;
  align-items: center;

  border-radius: ${(props) => props.theme.typography.pxToRem(4)};

  text-wrap: nowrap;
`
